import _ from '@sparta.global.vendors/lodash';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';

/*-----------------------------------------------------------------

utility: Magellan Utility
description: Utility for magellan and scrollspy functionality.
author: Jesse Price - jesse.price@bankofamerica.com

Data API:

<div data-magellan-expedition="true">
  <a href="#arrival" data-magellan-arrival="#arrival">Text</a>
</div>

<div data-magellan-destination="arrival">
  Section Content / Child modules.
</div>

-----------------------------------------------------------------*/
const EVENTS = {
  SPARTA_GLOBAL_READY: 'SPARTA_GLOBAL_READY.spartaBootstrapUtility'
};
const DATA_EXPEDITION = '[data-magellan-expedition]';
const DATA_ARRIVAL = '[data-magellan-arrival]';

/**
 * @class MagellanUtility
 */
class MagellanUtility {
  /**
   * Creates an instance of MagellanUtility.
   * @memberof MagellanUtility
   */
  constructor() {
    this.destinations = [];
    spartaEventsUtility.sub(EVENTS.SPARTA_GLOBAL_READY, () => {
      this.init();
    });
  }

  /**
   * @returns {void}
   */
  init() {
    this.setPositions();
    this.setupEvents();
  }

  /**
   * @returns {void}
   */
  setPositions() {
    this.destinations = []; // reset destinations
    _.forEach(document.querySelectorAll(DATA_EXPEDITION), expedition => {
      const expeditionOptions = expedition.dataset.options || null;
      let threshold = 15;
      if (expeditionOptions) {
        _.forEach(expeditionOptions.split(';').filter(s => s && s.length), option => {
          const keyValue = option.split(':');
          if (keyValue[0] === 'destination_threshold') {
            threshold = parseInt(keyValue[1], 10);
          }
        });
      }
      _.forEach(expedition.querySelectorAll(DATA_ARRIVAL), arrival => {
        const destination = document.querySelector(arrival.dataset.magellanArrival);
        const rect = destination.getBoundingClientRect();
        const arrivals = destination.dataset ? document.querySelectorAll(`[data-magellan-arrival='#${destination.dataset.magellanDestination}']`) : false;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        const top = rect.top + scrollTop - threshold;
        this.destinations.push({
          options: expeditionOptions,
          id: destination.id,
          top,
          bottom: top + destination.offsetHeight,
          dataset: destination.dataset,
          arrivals
        });
      });
    });
  }

  /**
   * @returns {void}
   */
  setupEvents() {
    const scrollHandler = this.scrollHandler.bind(this);
    window.addEventListener('scroll', _.throttle(scrollHandler, 100));
    const setPositions = this.setPositions.bind(this);
    window.addEventListener('resize', _.throttle(setPositions, 100));
  }

  /**
   * @returns {void}
   */
  scrollHandler() {
    this.setPositions();
    const winTop = window.pageYOffset;
    const stickyOffset = MagellanUtility.getStickyOffset();
    for (let i = 0, ii = this.destinations.length; i < ii; i += 1) {
      const destination = this.destinations[i];
      const offsetHeight = Number(destination.dataset.offsetHeight || 0);
      const top = destination.top - stickyOffset - offsetHeight;
      const bottom = destination.bottom - stickyOffset - offsetHeight;
      if (winTop >= top && winTop <= bottom) {
        if (destination.arrivals) {
          _.forEach(destination.arrivals, arrival => {
            MagellanUtility.removeActive(arrival);
            arrival.classList.add('active');
          });
        }
      }
    }
  }

  /**
   * @static
   * @param {HTMLElement} arrival element
   * @returns {void}
   */
  static removeActive(arrival) {
    _.forEach(document.querySelectorAll(`${DATA_ARRIVAL}`), current => {
      if (arrival !== current) {
        current.classList.remove('active');
      }
    });
  }

  /**
   * @static
   * @return {Number} height
   * @memberof MagellanUtility
   */
  static getStickyOffset() {
    let height = 0;
    _.forEach(document.querySelectorAll('.spa-sticky.active'), sticky => {
      const style = window.getComputedStyle(sticky);
      if (style.display !== 'none') {
        height += sticky.offsetHeight;
      }
    });
    return height;
  }
}
var index = new MagellanUtility();

export { index as default };
